/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceAlertConfiguration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceAlertConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceAlertConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceAlertConfiguration>): BackgroundJobPayloadForResourceAlertConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForResourceAlertConfiguration(), model);
        BackgroundJobPayloadForResourceAlertConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceAlertConfiguration>): BackgroundJobPayloadForResourceAlertConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForResourceAlertConfiguration.newInstance(<BackgroundJobPayloadForResourceAlertConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceAlertConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceAlertConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceAlertConfiguration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceAlertConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    resource_audit_log_id: string;

}
